module.exports = __webpack_public_path__ + "img/edit.664ea15c.svg";